import { render } from "./vuseradd.vue?vue&type=template&id=84137eae&scoped=true"
import script from "./vuseradd.vue?vue&type=script&lang=js"
export * from "./vuseradd.vue?vue&type=script&lang=js"

import "./vuseradd.vue?vue&type=style&index=0&id=84137eae&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84137eae"]])

export default __exports__